import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { ChatService } from '../../services/chat.service';
@Component({
  selector: 'app-user',
  standalone: false,
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent {
  ui: any = {}
  user: any;
  path: string = '';
  mainUi: any;
  groupedUI: any = [];
  ungroupedUI: any = [];
  shareObject: any = {};
  constructor(
    public sharedService: SharedService,
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private chatService: ChatService,
  ) { }
  ngOnInit(): void {
    this.sharedService.shareObject.sidebarOpen = true;
    this.user = this.sharedService.user;
    console.log('user', this.user);
    this.ui = [
      // { name: this.translate.instant('menu_employee_create'), path: '/user/employee/create', icon: 'bi bi-person-plus' },
      { roles: ["admin.index", "admin.super", "users.profile"], name: this.translate.instant('menu_employee_profile'), path: '/user/profile', icon: 'bi bi-person' },
      { roles: ["admin.index", "admin.super",], name: this.translate.instant('menu_chat'), path: '/user/chat', icon: 'bi bi-chat-dots' },

      { roles: ["admin.index", "admin.super", "users.index"], name: this.translate.instant('menu_employee_manager'), path: '/user/employee/manager', icon: 'bi bi-people', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_group.index"], name: this.translate.instant('menu_employee_group'), path: '/user/employee/group', icon: 'bi bi-person', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_timeshift.index"], name: this.translate.instant('menu_employee_timeshift'), path: '/user/employee/timesheet', icon: 'bi bi-clipboard2-data', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_calendar.index"], name: this.translate.instant('menu_employee_calendar'), path: '/user/employee/calendar', icon: 'bi bi-calendar2-check', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_attendance.index"], name: this.translate.instant('menu_employee_attendance'), path: '/user/employee/attendance/list', icon: 'bi bi-person-badge', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_attendance.index"], name: this.translate.instant('menu_employee_attendance_history'), path: '/user/employee/attendance/history', icon: 'bi bi-person-badge', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_store.index"], name: this.translate.instant('menu_employee_store'), path: '/user/employee/store', icon: 'bi bi-shop', group: this.translate.instant('employee') },
      // { roles: ["admin.index", "admin.super","1452"], name: this.translate.instant('menu_employee_faceid_station'), path: '/user/employee/attendance/faceid-station', icon: 'bi bi-pc-display-horizontal', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_face.index"], name: this.translate.instant('menu_employee_face'), path: '/user/employee/face', icon: 'bi bi-person-bounding-box', group: this.translate.instant('employee') },

      { roles: ["admin.index", "admin.super", "employee_overtime.index"], name: this.translate.instant('menu_employee_overtime'), path: '/user/employee/overtime', icon: 'bi bi-stopwatch', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_relocation.index"], name: this.translate.instant('menu_employee_relocation'), path: '/user/employee/relocation', icon: 'bi bi-person-gear', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_absence.index"], name: this.translate.instant('menu_employee_absence'), path: '/user/employee/absence', icon: 'bi bi-person-exclamation', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "employee_leave.index"], name: this.translate.instant('menu_employee_leave'), path: '/user/employee/leave', icon: 'bi bi-sign-turn-slight-right', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "1118"], name: this.translate.instant('menu_employee_formula_salary'), path: '/user/employee/formula/salary/list', icon: 'bi bi-stopwatch', group: this.translate.instant('employee') },
      { roles: ["admin.index", "admin.super", "1118"], name: this.translate.instant('menu_employee_timekeeping'), path: '/user/employee/formula/timekeeping', icon: 'bi bi-stopwatch', group: this.translate.instant('employee') },
      // { name: this.translate.instant('menu_employee_account'), path: '/user/employee/account', icon: 'bi bi-people'},
      // { name: this.translate.instant('menu_employee_salary'), path: '/user/employee/salary', icon: 'bi bi-cash' },

      // { name: this.translate.instant('menu_order_booking'), path: '/user/order/booking', icon: 'bi bi-cart' },
      // { name: this.translate.instant('menu_order_manager'), path: '/user/order/manager', icon: 'bi bi-receipt' },
      // { name: this.translate.instant('menu_order_production'), path: '/user/order/production', icon: 'bi bi-cake' },
      // { name: this.translate.instant('menu_order_warehouse'), path: '/user/order/warehouse', icon: 'bi bi-database-fill' },

      // { name: this.translate.instant('menu_phone_call'), path: '/user/phone/call', icon: 'bi bi-telephone-inbound' },
      { roles: ["admin.index", "admin.super", "phone.index"], name: this.translate.instant('menu_phone_manager'), path: '/user/phone/manager', icon: 'bi bi-telephone-outbound', group: this.translate.instant('phone') },
      { roles: ["admin.index", "admin.super", "phone_contact.index"], name: this.translate.instant('menu_phone_contact'), path: '/user/phone/contact', icon: 'bi bi-person-lines-fill', group: this.translate.instant('phone') },
      { roles: ["admin.index", "admin.super", "callrecord.index"], name: this.translate.instant('menu_phone_record'), path: '/user/phone/record', icon: 'bi bi-mic', group: this.translate.instant('phone') },

      // { name: this.translate.instant('menu_product_group'), path: '/user/product/group', icon: 'bi bi-cake' },
      // { name: this.translate.instant('menu_product_manager'), path: '/user/product/manager', icon: 'bi bi-cake' },

      // { name: this.translate.instant('menu_warehouse_export'), path: '/user/warehouse/export', icon: 'bi bi-file-earmark-arrow-up' },
      // { name: this.translate.instant('menu_warehouse_import'), path: '/user/warehouse/import', icon: 'bi bi-file-earmark-arrow-down' },
      // { name: this.translate.instant('menu_warehouse_manager'), path: '/user/warehouse/manager', icon: 'bi bi-database-fill' },
      // { name: this.translate.instant('menu_warehouse_material'), path: '/user/warehouse/material', icon: 'bi bi-basket2' },
      // { name: this.translate.instant('menu_warehouse_supplier'), path: '/user/warehouse/supplier', icon: 'bi bi-person-badge' },
      // { name: this.translate.instant('menu_warehouse_unit'), path: '/user/warehouse/unit', icon: 'bi bi-unity' },

      { roles: ["admin.index", "admin.super", "store_manager.index"], name: this.translate.instant('menu_store'), path: '/user/store/manager', icon: 'bi bi-shop', group: this.translate.instant('store') },
      // { name: this.translate.instant('menu_store_manager'), path: '/user/store/manager', icon: 'bi bi-shop' },
      // { name: this.translate.instant('menu_store_import'), path: '/user/store/import', icon: 'bi bi-database-fill-add' },
      // { name: this.translate.instant('menu_store_order'), path: '/user/store/order', icon: 'bi bi-receipt' },



    ].map((e: any) => {
      e.show = e.roles && e.roles.some((r: string) => this.user.roles.includes(r));
      return e;
    }).filter((e: any) => e.show);

    let groupedMap = new Map<string, any[]>();
    this.ungroupedUI = [];

    this.ui.forEach((item: any) => {
      if (item.group) {
        //thêm icon vào group là icon của item đầu tiên trong group
        if (!groupedMap.has(item.group)) {
          groupedMap.set(item.group, []);
        }
        groupedMap.get(item.group)!.push(item);
      } else {
        this.ungroupedUI.push(item);
      }
    });
    let currentPath = this.router.url;
    this.groupedUI = Array.from(groupedMap.entries()).map(([title, items]) => ({
      title,
      collapsed: items.some((item: any) => currentPath == item.path),
      items
    }));
    console.log('groupedUI', this.groupedUI);

    //navigate end
    this.router.events.subscribe((event) => {
      if (event.constructor.name === 'NavigationEnd') {
        let currentPath = this.router.url;
        this.groupedUI.forEach((group: any) => {
          group.collapsed = group.items.some((item: any) => currentPath == item.path);
          console.log('group', group.title, group.collapsed);
        });
      }
    });

    this.user = this.sharedService.user;
    this.mainUi = this.ui[this.user.userInterface]
    this.path = this.activatedRoute.firstChild?.snapshot.data['type'];
  }
  changeUserInterface(uInterface: string) {
    this.mainUi = this.ui[uInterface]
    this.router.navigate([this.mainUi[0].path]);
    this.sharedService.changeUserInterface(uInterface)
    console.log([this.mainUi[0].path])
  }
  toggleSidebar() {
    this.sharedService.shareObject.sidebarOpen = !this.sharedService.shareObject.sidebarOpen;
  }
  showHelp(item: any) {
    this.ui.forEach((e: any) => { e.showHelp = false; });
    item.showHelp = true;
    setTimeout(() => {
      item.showHelp = false;
    }, 3000);
  }
}
